import { z } from 'zod'
import { ContentfulRichTextDocumentSchema } from './common'

export const ContentfulStaticContentSchema = z.object({
  identifier: z.string().optional(),
  content: ContentfulRichTextDocumentSchema.optional(),
  contentType: z.literal('staticTextContent'),
})

export type ContentfulStaticContent = z.infer<typeof ContentfulStaticContentSchema>
